import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { CampanhaLeadVisualizacaoModo, campanhaLeadVisualizacaoModos } from './campanha-lead-visualizacao-modo';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'sgt-campanha-lead-visualizacao-modo',
    templateUrl: './campanha-lead-visualizacao-modo.component.html',
    styleUrls: ['./campanha-lead-visualizacao-modo.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampanhaLeadVisualizacaoModoComponent), multi: true },
    ]
})
export class CampanhaLeadVisualizacaoModoComponent {
    visualizacoesModos = campanhaLeadVisualizacaoModos;

    /** Modo de visualização */
    @Input() ngModel: number;
    /** Ao alterar a forma do contato */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Nome */
    @Input() name: string;
    /* ID */
    @Input() id: string;

    propagateChange: any = () => {};

    /** Ao selecionar a forma de contato */
    onChange(modo: CampanhaLeadVisualizacaoModo) {
        this.ngModel = modo ? modo.id : null;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
